export default __webpack_public_path__ + "static/home-regif-f70cd9a5ee50550527732422dfa05f7d.gif";